import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'
import { FaChevronDown } from 'react-icons/fa'
import { AnimatePresence, motion } from 'framer-motion'
import { colors } from '../../../utilities/colors'
import UnitRow from '../Units/UnitRow'
import SectionLabel from '../Quotes/wizard/SectionLabel'

export default function CarpoolVehiclesList({ vehicles, trailing }) {
  const { t } = useTranslation()
  const isCollapsible = vehicles.length > 1
  const [isOpen, setIsOpen] = useState(!isCollapsible)

  const [firstVehicle, ...remainingVehicles] = vehicles

  const defaultTrailing = (vehicle) => {
    const isOperable = !vehicle.inoperable
    const accent = isOperable ? colors.green : colors.yellow
    return (
      <Text
        fontSize="xs"
        fontWeight="semibold"
        px={2}
        py={0.5}
        borderRadius="full"
        border="1px solid"
        borderColor={accent}
        color={accent}
      >
        {isOperable ? t('Operable') : t('Inoperable')}
      </Text>
    )
  }

  const trailingFor = trailing || defaultTrailing

  const renderRow = (vehicle) => (
    <UnitRow
      key={vehicle.id || vehicle.vin}
      unit={{
        id: vehicle.id || vehicle.vin,
        attributes: {
          year: vehicle.year,
          make: vehicle.make,
          model: vehicle.model,
          vin: vehicle.vin,
        },
      }}
      trailing={trailingFor(vehicle)}
    />
  )

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <SectionLabel text={`${t('Vehicles')} (${vehicles.length})`} accent={colors.green} />
      <Box w="full" borderRadius="md" border="1px solid" borderColor={colors.grey700} overflow="hidden">
        {firstVehicle && renderRow(firstVehicle)}
        <AnimatePresence initial={false}>
          {isOpen && remainingVehicles.length > 0 && (
            <motion.div
              key="extras"
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2, ease: 'easeInOut' }}
              style={{ overflow: 'hidden' }}
            >
              {remainingVehicles.map(renderRow)}
            </motion.div>
          )}
        </AnimatePresence>
        {isCollapsible && (
          <Box
            as="button"
            type="button"
            w="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={2}
            py={1.5}
            borderTop="1px solid"
            borderColor={colors.grey700}
            color={colors.grey300}
            _hover={{ bg: colors.grey800 }}
            onClick={() => setIsOpen((open) => !open)}
          >
            <Text fontSize="xs" fontWeight="semibold" letterSpacing="wide">
              {isOpen ? t('Show less') : t('Show more')}
            </Text>
            <Box
              as={FaChevronDown}
              size="12px"
              transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
              transition="transform 0.2s ease-in-out"
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}
